import React from 'react'  
import Slider from "react-slick";
const HomeSlider = () => {
  var settings = { 
    autoplay: true,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,  
    arrows:true,
    adaptiveHeight: true, 
  };
  return (
   <>  
   <div className='homeslider'> 
      <Slider {...settings}>   
        <div className="item">
            <img src="https://webapi.entab.info/api/image/MMATD/public/Images/slider.jpg" className="d-block w-100" alt="MMATD"/> 
        </div>  
        <div className="item">
            <img src="https://webapi.entab.info/api/image/MMATD/public/Images/slider1.jpg" className="d-block w-100" alt="MMATD"/> 
        </div>
  </Slider>  
   </div>  
   </>
  )
}

export default HomeSlider
